import * as site from '@/services/admin/site'

export const namespaced = true

export const state = {
    site: {}
}

export const mutations = {
    LOAD(state, site) {
        state.site = site
    }
}

export const actions = {
    load({ commit }) {
        return site.load().then(result => commit('LOAD', result.site))
    },
    save({ commit }, mutatedSite) {
        return site.save(mutatedSite).then(() => commit('LOAD', mutatedSite))
    }
}